// extracted by mini-css-extract-plugin
export default {"wrap":"column_wrap__FU0n2"};